import { render, staticRenderFns } from "./pp.vue?vue&type=template&id=c3b13900&scoped=true"
import script from "./pp.vue?vue&type=script&lang=js"
export * from "./pp.vue?vue&type=script&lang=js"
import style0 from "./pp.vue?vue&type=style&index=0&id=c3b13900&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b13900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3b13900')) {
      api.createRecord('c3b13900', component.options)
    } else {
      api.reload('c3b13900', component.options)
    }
    module.hot.accept("./pp.vue?vue&type=template&id=c3b13900&scoped=true", function () {
      api.rerender('c3b13900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/pp.vue"
export default component.exports